import React, { useEffect, useState } from 'react';
import Logo from '../../../../components/Logo';
import NavLogo from '../../../../components/NavLogo';
import { getOfferListFilterStatus } from '../../../../utils/actions';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HeaderBanner from '../../../../layouts/HeaderBanner';
import * as app_consts from '../../../../utils/constants';

const AtsManagement = () => {
  const { entity_id, entity_mid } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const offers = useSelector((state) => state.offerListStatusFiltered.data);
  const [trades, setTrades] = useState('');
  const [bidtrades, setTradeBids] = useState('');
  const [totalTrades, setTotalTrades] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState({ commodity: '', location: '', type: '', status: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const filterData = (item) => {
    const searchTermMatch = item.commodity?.toLowerCase().includes(searchTerm.toLowerCase());
    const commodityFilterMatch = filter.commodity === '' || item.commodity?.toLowerCase() === filter.commodity?.toLowerCase();
    const locationFilterMatch = filter.location === '' || item.location?.toLowerCase() === filter.location?.toLowerCase();
    const typeFilterMatch =
      filter.type === '' ||
      (item.order_type?.toLowerCase() === "super_bid" ? "BIDS" : item.order_type?.toLowerCase()) === filter.order_type ||
      (item.order_type?.toLowerCase() === "super_offer" ? "OFFERS" : item.order_type?.toLowerCase()) === filter.order_type;
    const statusFilterMatch = filter.status === '' || (item.status?.toLowerCase() === filter.status.toLowerCase());

    return searchTermMatch && commodityFilterMatch && locationFilterMatch && typeFilterMatch && statusFilterMatch;
  };

  const getAllCommodities = () => {
    const allCommodities = new Set();
    if (bidtrades)
    {
      bidtrades.forEach((bid) => {
        allCommodities.add(bid.commodity?.toLowerCase());
      });
    }
    if (trades)
    {
      trades.forEach((offer) => {
        allCommodities.add(offer.commodity?.toLowerCase());
      });
    }
    return Array.from(allCommodities);
  };

  const getAllLocations = () => {
    const allLocations = new Set();

    if (bidtrades)
    {
      bidtrades.forEach((bid) => {
        allLocations.add(bid.location);
      });
    }

    if (trades)
    {
      trades.forEach((offer) => {
        allLocations.add(offer.location);
      });
    }

    return Array.from(allLocations);
  };

  const getAllTypes = () => {
    const allTypes = new Set();

    if (bidtrades)
    {
      bidtrades.forEach((bid) => {
        const type = bid && bid.length > 0
          ? bid.order_type?.toLowerCase() === "super_bid"
            ? "BIDS"
            : ''
          : '';
        allTypes.add(type);
      });
    }

    if (trades)
    {
      trades.forEach((offer) => {
        const type = offer && offer.length > 0
          ? offer.order_type?.toLowerCase() === "super_offer"
            ? "OFFERS"
            : ''
          : '';
        allTypes.add(type);
      });
    }

    return Array.from(allTypes);
  };

  const getAllStatuses = () => {
    const allStatuses = new Set();

    if (bidtrades)
    {
      bidtrades.forEach((bid) => {
        const status = bid.status?.toLowerCase();
        allStatuses.add(status);
      });
    }

    if (trades)
    {
      trades.forEach((offer) => {
        const status = offer.status?.toLowerCase();
        allStatuses.add(status);
      });
    }

    return Array.from(allStatuses);
  };

  const filteredBrokerOfferData = trades
    ? trades?.filter((item) => filterData(item))
    : [];

  const filteredBrokerBidData = bidtrades
    ? bidtrades?.filter((item) => filterData(item))
    : [];

  const [modal, setModal] = useState({
    createBidModal: false,
    individual: false,
    organization: false,
  });

  const closeBrokerOfferModal = () => {
    setModal({ ...modal, brokerOfferModal: false });
  };

  const openSelectedModal = (modalToBeOpened) => {
    setModal({ ...modal, [modalToBeOpened]: true });
  };


  useEffect(() => {
    if (offers?.broker_offer?.length !== 0)
    {
      let tradeMap = [];

      offers?.broker_offer?.map((offer) => {
        offer?.commodity_order?.map((commodity_order) => {
          let bidsData = [];

          if (offer.broker_bids && offer.broker_bids.length > 0)
          {
            bidsData = offer.broker_bids.map((bid) => ({
              bid_id: bid.id,
              broker_name: bid.broker_name,
              bid: bid.bid,
              date_submitted_to_platform: bid.date_submitted_to_platform,
              date_to_be_placed_on_platform: bid.date_to_be_placed_on_platform,
              date_to_be_withdrawn_from_platform: bid.date_to_be_withdrawn_from_platform,
              commodity: bid.commodity,
              unit_of_measure: bid.unit_of_measure,
              volume: bid.volume,
              requested_unit_price: bid.requested_unit_price,
              quality: bid.quality,
              other_documentation_required: bid.other_documentation_required,
              order_type: bid.order_type,
              special_terms_and_conditions: bid.special_terms_and_conditions,
              broker_bid_reference_no: bid.broker_bid_reference_no,
              broker_bid_date: bid.broker_bid_date,
              location: bid.location,
              delivery: bid.delivery,
              commodity_order_id: bid.commodity_order_id,
              warehouse_receipt_id: bid.warehouse_receipt_id,
              participant_id: bid.participant_id,
              bid_volume: bid.bid_volume,
              bid_total: bid.bid_total,
              status: bid.status,
            }));
          }

          tradeMap.push({
            //offer data
            volume_on_offer: offer.volume_on_offer,
            broker_id: offer.broker_id,
            commodity: offer.commodity,
            date_submitted_to_platform: offer.date_submitted_to_platform,
            date_to_be_placed_on_platform: offer.date_to_be_placed_on_platform,
            delivery: offer.delivery,
            history: offer.history,
            id: offer.id,
            location: offer.location,
            order_type: offer.order_type,
            other_documentation_required: offer.other_documentation_required,
            producer_id: offer.producer_id,
            quality: offer.quality,
            requested_unit_price: offer.requested_unit_price,
            special_terms_and_conditions: offer.special_terms_and_conditions,
            status: offer.status,
            volume: offer.volume,
            warehouse_receipt_id: offer.warehouse_receipt_id,
            commodity_order_status: commodity_order?.status,
            //commodity order data
            commodity_order_reference_no:
              commodity_order.commodity_order_reference_no,
            commodity_order_id: commodity_order.id,

            //bids data
            bids: bidsData,
          });
        });
      });

      setTrades(tradeMap);
    }
  }, [offers]);

  useEffect(() => {
    if (offers?.broker_bids?.length !== 0)
    {
      let tradeBidsMap = [];

      offers?.broker_bids?.map((bid) => {
        bid?.commodity_order?.map((commodity_order) => {
          let brokerOffersData = [];

          if (bid.broker_offers && bid.broker_offers.length > 0)
          {
            brokerOffersData = bid.broker_offers.map((brokerOffer) => ({
              broker_id: brokerOffer.broker_id,
              broker_offer_date: brokerOffer.broker_offer_date,
              broker_offer_reference_no: brokerOffer.broker_offer_reference_no,
              commodity: brokerOffer.commodity,
              date_submitted_to_platform: brokerOffer.date_submitted_to_platform,
              date_to_be_placed_on_platform: brokerOffer.date_to_be_placed_on_platform,
              date_to_be_withdrawn_from_platform: brokerOffer.date_to_be_withdrawn_from_platform,
              delivery: brokerOffer.delivery,
              history: brokerOffer.history,
              id: brokerOffer.id,
              inserted_at: brokerOffer.inserted_at,
              location: brokerOffer.location,
              offer: brokerOffer.offer,
              offer_owner: brokerOffer.offer_owner,
              offer_total: brokerOffer.offer_total,
              offer_volume: brokerOffer.offer_volume,
              order_type: brokerOffer.order_type,
              other_documentation_required: brokerOffer.other_documentation_required,
              producer_id: brokerOffer.producer_id,
              quality: brokerOffer.quality,
              requested_unit_price: brokerOffer.requested_unit_price,
              special_terms_and_conditions: brokerOffer.special_terms_and_conditions,
              status: brokerOffer.status,
              unit_of_measure: brokerOffer.unit_of_measure,
              volume: brokerOffer.volume,
              volume_on_offer: brokerOffer.volume_on_offer,
              warehouse_receipt_id: brokerOffer.warehouse_receipt_id,
            }));
          }

          tradeBidsMap.push({
            // bid properties
            bid: bid.bid,
            bid_total: bid.bid_total,
            bid_volume: bid.bid_volume,
            date_to_be_placed_on_platform: bid.date_to_be_placed_on_platform,
            commodity: bid.commodity,
            id: bid.id,
            status: bid.status,
            broker_bid_date: bid.broker_bid_date,
            broker_bid_reference_no: bid.broker_bid_reference_no,
            broker_id: bid.broker_id,
            broker_name: bid.broker_name,

            // broker offers data
            broker_offers: brokerOffersData,
            commodity_order_status: commodity_order?.status,
            // commodity order data
            commodity_order_reference_no: commodity_order?.commodity_order_reference_no,
            commodity_order_id: commodity_order?.id,

          });
        });
      });

      setTradeBids(tradeBidsMap);
    }
  }, [offers]);



  useEffect(() => {
    setLoading(true);
    dispatch(getOfferListFilterStatus(currentPage, pageSize, AtsManagement)).then(
      (response) => {
        setLoading(false);
      }
    );
  }, [currentPage, dispatch]);

  const numberFormat = new Intl.NumberFormat('en-ZM', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  //   const filteredBrokerOffers = brokerOffers.filter((brokerOffers) => {
  //     const combinedParams = [
  //       brokerOffers.warehouse_receipt_id,
  //       brokerOffers.commodity,
  //       // brokerOffers.date_to_be_placed_on_platform,
  //       // brokerOffers.order_type,
  //       // brokerOffers.quality,
  //       // brokerOffers.volume,
  //     ]
  //       .join(' ')
  //       .toLowerCase();

  //     return combinedParams.includes(searchTerm.toLowerCase());
  //   });

  //   const displayedBrokerOffers = filteredBrokerOffers
  //     ? filteredBrokerOffers.slice(startIndex, endIndex)
  //     : [];

  // Pagination handlers
  //   const nextPage = () => {
  //     if (currentPage * pageSize < totalBrokerOffers)
  //     {
  //       setCurrentPage(currentPage + 1);
  //     }
  //   };

  //   const prevPage = () => {
  //     if (currentPage > 1)
  //     {
  //       setCurrentPage(currentPage - 1);
  //     }
  //   };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <>
      <div>
        <button
          data-drawer-target='logo-sidebar'
          data-drawer-toggle='logo-sidebar'
          aria-controls='logo-sidebar'
          type='button'
          className='inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600'
        >
          <span className='sr-only'>Open sidebar</span>
          <svg
            className='w-6 h-6'
            aria-hidden='true'
            fill='currentColor'
            viewBox='0 0 20 20'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              clip-rule='evenodd'
              fill-rule='evenodd'
              d='M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z'
            ></path>
          </svg>
          <NavLogo />
        </button>

        <aside
          id='logo-sidebar'
          className='fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0'
          aria-label='Sidebar'
        >
          <div className='h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800'>
            <a href='/' className='flex items-center pl-2.5 mb-5'>
              <Logo />
            </a>

            <ul className='space-y-2 font-medium'>
              <li>
                <a
                  href='/home'
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    class='w-6 h-6  dark:text-white'
                    aria-hidden='true'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 18 18'
                  >
                    <path
                      stroke='currentColor'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      stroke-width='2'
                      d='M6.143 1H1.857A.857.857 0 0 0 1 1.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 6.143V1.857A.857.857 0 0 0 6.143 1Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 17 6.143V1.857A.857.857 0 0 0 16.143 1Zm-10 10H1.857a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 16.143v-4.286A.857.857 0 0 0 6.143 11Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286a.857.857 0 0 0-.857-.857Z'
                    />
                  </svg>
                  <span className='ml-3'>My Dashboards</span>
                </a>
              </li>
              <li>
                <a
                  href={`/exchange/${entity_id}/${entity_mid}`}
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    className='w-6 h-6'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6'
                    />
                  </svg>
                  <span className='ml-3'>Exchange Dashboard</span>
                </a>
              </li>
              {/* 
              <li>
                <a
                  href={`/broker/${entity_id}/${entity_mid}/customer_management`}
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z'
                    />
                  </svg>
                  <span className='ml-3'>Clients</span>
                </a>
              </li>
              <li>
                <a href={`/broker/${entity_id}/${entity_mid}/bid_management`}
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z'
                    />
                  </svg>
                  <span className='ml-3'>Bids</span>
                </a>
              </li>
              <li>
                <a
                  href={`/broker/${entity_id}/${entity_mid}/offer_management`}
                  className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m.75 12l3 3m0 0l3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z'
                    />
                  </svg>
                  <span className='ml-3'>Offers</span>
                </a>
              </li>
              <li>
                <a
                  href={`/broker/${entity_id}/${entity_mid}/live_market`}
                  className='flex items-center p-2 text-green-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z'
                    />
                  </svg>
                  <span className='ml-3'>ATS</span>
                </a>
              </li> */}
              <li>
                <a className='cursor-not-allowed flex items-center p-2 text-gray-400 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'>
                  <svg
                    class='w-6 h-6 dark:text-white'
                    aria-hidden='true'
                    viewBox='0 0 20 18'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M6.5 8C5.80777 8 5.13108 7.79473 4.55551 7.41015C3.97993 7.02556 3.53133 6.47893 3.26642 5.83939C3.00152 5.19985 2.9322 4.49612 3.06725 3.81719C3.2023 3.13825 3.53564 2.51461 4.02513 2.02513C4.51461 1.53564 5.13825 1.2023 5.81719 1.06725C6.49612 0.932205 7.19985 1.00152 7.83939 1.26642C8.47893 1.53133 9.02556 1.97993 9.41015 2.55551C9.79473 3.13108 10 3.80777 10 4.5'
                      stroke='currentColor'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M6.5 17H1V15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11'
                      stroke='currentColor'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M19.5 11H18.38C18.2672 10.5081 18.0714 10.0391 17.801 9.613L18.601 8.818C18.6947 8.72424 18.7474 8.59708 18.7474 8.4645C18.7474 8.33192 18.6947 8.20476 18.601 8.111L17.894 7.404C17.8002 7.31026 17.6731 7.25761 17.5405 7.25761C17.4079 7.25761 17.2808 7.31026 17.187 7.404L16.392 8.204C15.9647 7.93136 15.4939 7.73384 15 7.62V6.5C15 6.36739 14.9473 6.24021 14.8536 6.14645C14.7598 6.05268 14.6326 6 14.5 6H13.5C13.3674 6 13.2402 6.05268 13.1464 6.14645C13.0527 6.24021 13 6.36739 13 6.5V7.62C12.5081 7.73283 12.0391 7.92863 11.613 8.199L10.818 7.404C10.7242 7.31026 10.5971 7.25761 10.4645 7.25761C10.3319 7.25761 10.2048 7.31026 10.111 7.404L9.404 8.111C9.31026 8.20476 9.25761 8.33192 9.25761 8.4645C9.25761 8.59708 9.31026 8.72424 9.404 8.818L10.204 9.618C9.9324 10.0422 9.73492 10.5096 9.62 11H8.5C8.36739 11 8.24021 11.0527 8.14645 11.1464C8.05268 11.2402 8 11.3674 8 11.5V12.5C8 12.6326 8.05268 12.7598 8.14645 12.8536C8.24021 12.9473 8.36739 13 8.5 13H9.62C9.73283 13.4919 9.92863 13.9609 10.199 14.387L9.404 15.182C9.31026 15.2758 9.25761 15.4029 9.25761 15.5355C9.25761 15.6681 9.31026 15.7952 9.404 15.889L10.111 16.596C10.2048 16.6897 10.3319 16.7424 10.4645 16.7424C10.5971 16.7424 10.7242 16.6897 10.818 16.596L11.618 15.796C12.0422 16.0676 12.5096 16.2651 13 16.38V17.5C13 17.6326 13.0527 17.7598 13.1464 17.8536C13.2402 17.9473 13.3674 18 13.5 18H14.5C14.6326 18 14.7598 17.9473 14.8536 17.8536C14.9473 17.7598 15 17.6326 15 17.5V16.38C15.4919 16.2672 15.9609 16.0714 16.387 15.801L17.182 16.601C17.2758 16.6947 17.4029 16.7474 17.5355 16.7474C17.6681 16.7474 17.7952 16.6947 17.889 16.601L18.596 15.894C18.6897 15.8002 18.7424 15.6731 18.7424 15.5405C18.7424 15.4079 18.6897 15.2808 18.596 15.187L17.796 14.392C18.0686 13.9647 18.2662 13.4939 18.38 13H19.5C19.6326 13 19.7598 12.9473 19.8536 12.8536C19.9473 12.7598 20 12.6326 20 12.5V11.5C20 11.3674 19.9473 11.2402 19.8536 11.1464C19.7598 11.0527 19.6326 11 19.5 11ZM14 14.5C13.5055 14.5 13.0222 14.3534 12.6111 14.0787C12.2 13.804 11.8795 13.4135 11.6903 12.9567C11.5011 12.4999 11.4516 11.9972 11.548 11.5123C11.6445 11.0273 11.8826 10.5819 12.2322 10.2322C12.5819 9.8826 13.0273 9.6445 13.5123 9.54804C13.9972 9.45157 14.4999 9.50108 14.9567 9.6903C15.4135 9.87952 15.804 10.2 16.0787 10.6111C16.3534 11.0222 16.5 11.5055 16.5 12C16.5 12.663 16.2366 13.2989 15.7678 13.7678C15.2989 14.2366 14.663 14.5 14 14.5Z'
                      fill='currentColor'
                    />
                  </svg>

                  <span className='flex-1 ml-3 whitespace-nowrap'>
                    My Profile
                  </span>
                </a>
              </li>
              <li className='my-2 fixed bottom-12 w-11/12'>
                <a
                  onClick={handleLogout}
                  className='cursor-pointer flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
                >
                  <svg
                    class='w-6 h-6 dark:text-white'
                    aria-hidden='true'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 16 16'
                  >
                    <path
                      stroke='currentColor'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      stroke-width='2'
                      d='M4 8h11m0 0-4-4m4 4-4 4m-5 3H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3'
                    />
                  </svg>
                  <span className='flex-1 ml-3 whitespace-nowrap'>
                    Sign Out
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </aside>

        <div className='p-4 sm:ml-64'>
          <div className='p-4 rounded-lg dark:border-gray-700'>
            <HeaderBanner
              title='Automated Trading System'
              type={app_consts.OFFER_MANAGEMENT}
              home={`home`}
            />
            {/* <div class='w-full relative bg-white dark:bg-gray-800 sm:rounded-lg'>
            <div class='flex flex-col items-center justify-between p-4 space-y-3 md:flex-row md:space-y-0 md:space-x-4'>
              <div class='w-full md:w-1/2'>
                <form class='flex items-center'>
                  <label for='simple-search' class='sr-only'>
                    Search
                  </label>
                  <div class='relative w-full'>
                    <div class='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
                      <svg
                        aria-hidden='true'
                        class='w-5 h-5 text-gray-500 dark:text-gray-400'
                        fill='currentColor'
                        viewbox='0 0 20 20'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          fill-rule='evenodd'
                          d='M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z'
                          clip-rule='evenodd'
                        />
                      </svg>
                    </div>
                    <input
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      type='text'
                      id='simple-search'
                      class='block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500'
                      placeholder='Search'
                      required=''
                    />
                  </div>
                </form>
              </div>
              <div class='flex flex-col items-stretch justify-end flex-shrink-0 w-full space-y-2 md:w-auto md:flex-row md:space-y-0 md:items-center md:space-x-3'>
                <button
                  type='button'
                  onClick={() => setModal({ brokerOfferModal: true })}
                  className='flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 20 20'
                    fill='currentColor'
                    className='w-5 h-5 mr-2'
                  >
                    <path d='M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z' />
                    <path d='M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z' />
                  </svg>
                  Create New Offer
                </button>
                <div class='flex items-center w-full space-x-3 md:w-auto'>
                  <button
                    id='actionsDropdownButton'
                    data-dropdown-toggle='actionsDropdown'
                    class='flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700'
                    type='button'
                  >
                    <svg
                      class='-ml-1 mr-1.5 w-5 h-5'
                      fill='currentColor'
                      viewbox='0 0 20 20'
                      xmlns='http://www.w3.org/2000/svg'
                      aria-hidden='true'
                    >
                      <path
                        clip-rule='evenodd'
                        fill-rule='evenodd'
                        d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                      />
                    </svg>
                    Actions
                  </button>
                  <div
                    id='actionsDropdown'
                    class='z-10 hidden bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700 dark:divide-gray-600'
                  >
                    <ul
                      class='py-1 text-sm text-gray-700 dark:text-gray-200'
                      aria-labelledby='actionsDropdownButton'
                    >
                      <li>
                        <a
                          href='#'
                          class='block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white'
                        >
                          Mass Edit
                        </a>
                      </li>
                    </ul>
                    <div class='py-1'>
                      <a
                        href='#'
                        class='block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white'
                      >
                        Delete all
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div> */}
            <div className='relative'>
              <br />

              <div class='w-full md:w'>
                <h1 class='text-4xl font-bold dark:text-white'>
                  Commodity Exchange
                  <small class='ml-2 font-semibold text-gray-400 dark:text-gray-300'>
                    Current Listings
                  </small>
                </h1>
                <br />
                <div className="pb-4 bg-white dark:bg-gray-900 flex items-center">
                  <label htmlFor="table-search" className="sr-only">Search</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path>
                      </svg>
                    </div>
                    <input
                      type="text"
                      className="block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-green-500 focus:border-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                      placeholder="Search for a commodity"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>

                  <div className="relative ml-3">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <svg className="w-5 h-5 text-blue-500" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 12l-4.95 4.95L15 17l6-6-6-6 1.05-1.05L21 12zm-14 0l4.95-4.95L9 7l-6 6 6 6-1.05 1.05L3 12z" />
                      </svg>
                    </div>
                    <select
                      className="block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-green-500 focus:border-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                      onChange={(e) => setFilter({ ...filter, commodity: e.target.value })}
                    >
                      <option value="">Filter By Commodity</option>
                      {getAllCommodities().map((commodity) => (
                        <option key={commodity} value={commodity}>
                          {commodity?.replace(/_/g, ' ').toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="relative ml-3">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-blue-500"
                        aria-hidden="true"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M21 12l-4.95 4.95L15 17l6-6-6-6 1.05-1.05L21 12zm-14 0l4.95-4.95L9 7l-6 6 6 6-1.05 1.05L3 12z" />
                      </svg>
                    </div>
                    <select
                      className="block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-green-500 focus:border-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                      onChange={(e) => setFilter({ ...filter, type: e.target.value })}
                    >
                      <option value="">Filter By Type</option>
                      {getAllTypes().map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="relative ml-3">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <svg className="w-5 h-5 text-blue-500" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 12l-4.95 4.95L15 17l6-6-6-6 1.05-1.05L21 12zm-14 0l4.95-4.95L9 7l-6 6 6 6-1.05 1.05L3 12z" />
                      </svg>
                    </div>
                    <select
                      className="block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-green-500 focus:border-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                      onChange={(e) => setFilter({ ...filter, status: e.target.value })}
                    >
                      <option value="">Filter By Status</option>
                      {getAllStatuses().map((status) => (
                        <option key={status} value={status}>
                          {status?.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="relative ml-3">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <svg
                        className="w-5 h-5 text-blue-500"
                        aria-hidden="true"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M21 12l-4.95 4.95L15 17l6-6-6-6 1.05-1.05L21 12zm-14 0l4.95-4.95L9 7l-6 6 6 6-1.05 1.05L3 12z" />
                      </svg>
                    </div>
                    <select
                      className="block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-green-500 focus:border-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                      onChange={(e) => setFilter({ ...filter, location: e.target.value })}
                    >
                      <option value="">Filter By Location</option>
                      {getAllLocations().map((location) => (
                        <option key={location} value={location}>
                          {location}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <br />
                <table className='w-full text-sm text-left text-gray-500 dark:text-gray-400'>
                  <thead className='text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400'>
                    <tr>
                      <th scope='col' className='px-2 py-3'>
                        Reference No.
                      </th>
                      <th scope='col' className='px-2 py-3'>
                        Date
                      </th>
                      <th scope='col' className='px-2 py-3'>
                        Commodity
                      </th>
                      <th scope='col' className='px-2 py-3'>
                        Type
                      </th>
                      <th scope='col' className='px-2 py-3'>
                        Unit Price
                      </th>
                      <th scope='col' className='px-2 py-3'>
                        Quantity (MT)
                      </th>
                      {/* <th scope='col' className='px-2 py-3'>
                        Total
                      </th> */}
                      <th scope='col' className='px-2 py-3'>
                        Location
                      </th>
                      <th scope='col' className='px-2 py-3'>
                        Delivery
                      </th>
                      <th scope='col' className='px-2 py-3'>
                        Conditions
                      </th>
                      <th scope='col' className='px-2 py-3'>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredBrokerOfferData &&
                      filteredBrokerOfferData?.map((trade, index) => (
                        <React.Fragment key={index}>
                          {/* Trade Row */}
                          <tr
                            className='border-b bg-gray-50 dark:bg-gray-800 dark:border-gray-700 font-bold'
                          >
                            <th
                              scope='row'
                              className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'
                            >
                              {trade?.commodity_order_reference_no}
                            </th>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.date_to_be_placed_on_platform}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.commodity.replace(/_/g, ' ').toUpperCase()}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade ? 'OFFER' : 'BID'}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.offer ? `${numberFormat.format(trade?.offer)} ZMW` : ""}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.volume_on_offer}
                            </td>
                            {/* <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              K
                              {numberFormat.format(
                                parseFloat(trade?.requested_unit_price) *
                                parseFloat(trade?.volume_on_offer)
                              )}
                            </td> */}
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.location}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.delivery}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.special_terms_and_conditions}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              <a
                                href={`/markets/offer_details/${trade?.id}`}
                              >
                                <button
                                  type='button'
                                  className='text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-3 py-2.5 text-center inline-flex items-center dark:focus:ring-primary-800 mr-2 mb-2'
                                >
                                  Offer Details
                                </button>
                              </a>
                            </td>
                          </tr>

                          {/* Bids Row */}
                          {trade?.bids && trade?.bids.length > 0 && trade?.bids.map((bid, bidIndex) => (
                            <tr key={bidIndex} className='border-b bg-gray-100 dark:bg-gray-700 dark:border-gray-700 font-normal'>
                              <td scope='row' className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {bid.broker_bid_reference_no}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {bid.broker_bid_date}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {bid.commodity.replace(/_/g, ' ').toUpperCase()}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                BID
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {bid?.requested_unit_price ? `${numberFormat.format(bid?.requested_unit_price)} ZMW` : ""}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {bid.bid_volume}
                              </td>
                              {/* <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                K{numberFormat.format(bid?.bid_total)}
                              </td> */}
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {bid.location}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {bid.delivery}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              </td>
                            </tr>
                          ))}

                        </React.Fragment>
                      ))}
                  </tbody>

                  <tbody>
                    {bidtrades &&
                      bidtrades?.map((trade, index) => (
                        <React.Fragment key={index}>
                          {/* Trade Row */}
                          <tr
                            className='border-b bg-gray-50 dark:bg-gray-800 dark:border-gray-700 font-bold'
                          >
                            <th
                              scope='row'
                              className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'
                            >
                              {trade?.commodity_order_reference_no}
                            </th>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.date_to_be_placed_on_platform}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.commodity.replace(/_/g, ' ').toUpperCase()}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade ? 'BID' : 'OFFER'}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.requested_unit_price ? `${numberFormat.format(trade?.requested_unit_price)} ZMW` : ""}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.volume_on_offer}
                            </td>
                            {/* <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              K
                              {numberFormat.format(
                                parseFloat(trade?.requested_unit_price) *
                                parseFloat(trade?.volume_on_offer)
                              )}
                            </td> */}
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.location}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.delivery}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              {trade?.special_terms_and_conditions}
                            </td>
                            <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              <a
                                // href={`/broker/${entity_id}/${entity_mid}/live_market/${trade.id}`}
                                href={`/markets/bid_details/${trade?.id}`}
                              >
                                <button
                                  type='button'
                                  className='text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-3 py-2.5 text-center inline-flex items-center dark:focus:ring-primary-800 mr-2 mb-2'
                                >
                                  Bid Details
                                </button>
                              </a>
                            </td>
                          </tr>

                          {/* Broker Offers Row */}
                          {trade?.broker_offers && trade?.broker_offers.length > 0 && trade?.broker_offers.map((brokerOffer, brokerOfferIndex) => (
                            <tr key={brokerOfferIndex} className='border-b bg-gray-100 dark:bg-gray-700 dark:border-gray-700 font-normal'>
                              <td scope='row' className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {brokerOffer.broker_offer_reference_no}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {brokerOffer.date_to_be_placed_on_platform}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {brokerOffer.commodity.replace(/_/g, ' ').toUpperCase()}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                OFFER
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {brokerOffer?.requested_unit_price ? `${numberFormat.format(brokerOffer?.requested_unit_price)} ZMW` : ""}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {brokerOffer?.volume_on_offer}
                              </td>
                              {/* <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                K{numberFormat.format(parseFloat(brokerOffer?.requested_unit_price) * parseFloat(brokerOffer?.volume_on_offer))}
                              </td> */}
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {brokerOffer?.location}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {brokerOffer?.delivery}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                                {brokerOffer?.special_terms_and_conditions}
                              </td>
                              <td className='px-2 py-4 font-sm text-gray-900 whitespace-nowrap dark:text-white'>
                              </td>
                            </tr>
                          ))}

                        </React.Fragment>
                      ))}
                  </tbody>
                </table>

              </div>

              <nav
                className='flex items-center justify-between pt-4'
                aria-label='Table navigation'
              >
                {/* Pagination controls */}
                <div className='flex items-center justify-between mt-4'>
                  <div className='flex-1'>
                    {/* <p className='text-sm text-gray-800 dark:text-gray-400'>
                    Showing {startIndex + 1}-{Math.min(endIndex, totalBrokerOffers)}{' '}
                    of {totalBrokerOffers} offers
                  </p> */}
                  </div>

                  {/* <div className='flex'>
                  <button
                    // onClick={prevPage}
                    disabled={currentPage === 1}
                    className='px-3 py-1 text-sm text-gray-500 dark:text-gray-400 rounded-full border border-grey-100 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-white'
                  >
                    Previous
                  </button>
                  <button
                    // onClick={nextPage}
                    // disabled={currentPage * pageSize >= totalBrokerOffers}
                    className='ml-2 px-3 py-1 text-sm text-gray-500 dark:text-gray-400 rounded-full border border-grey-100 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-white'
                  >
                    Next
                  </button>
                </div> */}
                </div>
              </nav>
              {loading && (
                <div className='text-center'>
                  <div role='status'>
                    <svg
                      aria-hidden='true'
                      className='inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-600'
                      viewBox='0 0 100 101'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                        fill='currentColor'
                      />
                      <path
                        d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                        fill='currentFill'
                      />
                    </svg>
                    <span className='sr-only'>Please wait...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AtsManagement;